import { useState, type FormEvent } from 'react'
import { Link, useNavigate } from 'react-router'
import { Button, Field, Stack, Text } from '@/design-system'
import { useAuth } from '@/app/auth/auth-context'
import { AuthFooter, AuthHeading, OrDivider, SocialRow } from './AuthForm'
import { BRAND } from '@/brand/brand'

export function SignUpScreen() {
  const navigate = useNavigate()
  const { login } = useAuth()
  const [email, setEmail] = useState(`alex@${BRAND.domain}`)
  const [submitting, setSubmitting] = useState(false)

  async function handleSubmit(event: FormEvent) {
    event.preventDefault()
    setSubmitting(true)
    await login({ email, password: 'passbank' })
    navigate('/onboarding/accounts', { replace: true })
  }

  return (
    <Stack as="form" gap={6} onSubmit={handleSubmit}>
      <AuthHeading
        title="Create account"
        subtitle="Free to open — start it with $50, which stays yours. No monthly fee, no minimum balance."
      />

      <Stack gap={3}>
        <Field label="Full name" autoComplete="name" defaultValue="Alex Turner" />
        <Field
          label="Email"
          type="email"
          autoComplete="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
        <Field label="Password" type="password" autoComplete="new-password" defaultValue="••••••••••" />
      </Stack>

      <Button type="submit" size="lg" block disabled={submitting}>
        {submitting ? 'Creating…' : 'Create account'}
      </Button>

      <OrDivider />
      <SocialRow />

      <Text variant="caption" tone="secondary">
        By continuing you agree to our{' '}
        <Link to="/legal/terms">
          <Text as="span" variant="caption" weight="semibold" tone="primary">
            Terms
          </Text>
        </Link>{' '}
        and{' '}
        <Link to="/legal/privacy">
          <Text as="span" variant="caption" weight="semibold" tone="primary">
            Privacy Policy
          </Text>
        </Link>
        .
      </Text>

      <AuthFooter question="Already have an account?" actionLabel="Log in" to="/login" />
    </Stack>
  )
}
